import { NgModule } from '@angular/core';
import { SharedModule } from '../../../shared/shared.module';
import { MatLegacyDialogModule as MatDialogModule } from '@angular/material/legacy-dialog';
import { ConfirmWithSelectionDialogComponent } from './confirm-with-selection-dialog.component';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { MatLegacySelectModule as MatSelectModule } from '@angular/material/legacy-select';

@NgModule({
    declarations: [
        ConfirmWithSelectionDialogComponent,
    ],
    imports: [
        SharedModule,
        MatDialogModule,
        MatInputModule,
        MatSelectModule,
    ],
    exports: [
        ConfirmWithSelectionDialogComponent,
    ],
})
export class ConfirmWithSelectionDialogModule
{
}
